module.exports = __webpack_public_path__ + "static/media/print.a2baade4.svg";